import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ErrorPage } from './Component/Common/errorpage';
import { MainLayout } from './Component/Common/MainLayout';
import { LoginLayout } from './Component/Login/LoginLayout';
import { Signin } from './Component/Login/Signin';
import { Signup } from './Component/Login/Signup';
import { ForgotPin } from './Component/Login/fpin';
import { ResetPassword } from './Component/Login/rpass';
import { Home } from './Component/App/Home';
import 'bootstrap/dist/css/bootstrap.min.css';
import { NewClient } from './Component/Client/NewClient';
import { EditClient } from './Component/Client/EditClient';
import { ProfileLayout } from './Component/Client/ProfileLayout';
import { Profile } from './Component/Client/Profile';
import { EditProfile } from './Component/Client/EditProfile';
import { ChangeCommunication } from './Component/Client/ChangeCommunication';
import { ChangePassword } from './Component/Client/ChangePassword';
import { ChangePin } from './Component/Client/ChangePin';
import { ChangeAstrologerConfig } from './Component/Client/ChangeAstrologerConfig';
import { ChangeClientConfig } from './Component/Client/ChangeClientConfig';
import { Events } from './Component/App/Events';
import { DeleteClient } from './Component/Client/DeleteClient';
import { BasicAstro } from './Component/App/BasicAstro';
import { KPAstro } from './Component/App/KPAstro';
import { ClientDetailsPage } from './Component/App/ClientDetailsPage';
import { RulingPlanetPage } from './Component/App/RulingPlanetPage';
import { TransitChartPage } from './Component/App/TransitChartPage';
import { BirthTimeCorrectionPage } from './Component/App/BirthTimeCorrectionPage';
import { KPInterLinks } from './Component/App/KPInterLinks';
import { OptionsTheory } from './Component/App/OptionsTheory';
import { OptionsTheoryPage } from './Component/App/Common/OptionsTheoryPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainLayout />} >
          <Route path="/" element={<LoginLayout />} >
            <Route index element={<Signin />} />
            <Route path="signup.html" element={<Signup />} />
            <Route path="fpin.html" element={<ForgotPin />} />
            <Route path="rpass.html" element={<ResetPassword />} />
          </Route>
          <Route path="/home.html" element={<Home />} />
          <Route path="/clientdetails.html" element={<ClientDetailsPage />} />
          <Route path="/rulingplanet.html" element={<RulingPlanetPage />} />
          <Route path="/transitchart.html" element={<TransitChartPage />} />
          <Route path="/timecorrection.html" element={<BirthTimeCorrectionPage />} />
          <Route path="/basicastro.html" element={<BasicAstro />} />
          <Route path="/kpastro.html" element={<KPAstro />} />
          <Route path="/kpinterlinks.html" element={<KPInterLinks />} />
          <Route path="/events.html" element={<Events />} />
          <Route path="/options.html" element={<OptionsTheory />} />
          <Route path="/newclient.html" element={<NewClient />} />
          <Route path="/editclient.html" element={<EditClient />} />
          <Route path="/deleteclient.html" element={<DeleteClient />} />
          <Route path="/optionstheory.html" element={<OptionsTheoryPage />} />
          <Route path="/profile.html" element={<ProfileLayout />} >
            <Route index element={<Profile />} />
          </Route>
          <Route path="/cprofile.html" element={<ProfileLayout />} >
            <Route index element={<EditProfile />} />
          </Route>
          <Route path="/ccom.html" element={<ProfileLayout />} >
            <Route index element={<ChangeCommunication />} />
          </Route>
          <Route path="/cpin.html" element={<ProfileLayout />} >
            <Route index element={<ChangePin />} />
          </Route>
          <Route path="/cpass.html" element={<ProfileLayout />} >
            <Route index element={<ChangePassword />} />
          </Route>
          <Route path="/caconfig.html" element={<ProfileLayout />} >
            <Route index element={<ChangeAstrologerConfig />} />
          </Route>
          <Route path="/ccconfig.html" element={<ProfileLayout />} >
            <Route index element={<ChangeClientConfig />} />
          </Route>
          <Route  path="/*" element={<ErrorPage />} />
        </Route>
        <Route  path="*" element={<ErrorPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
